import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";

const FieldSettingsQuestionMapping = (props) => {
  const [contextData] = useContext(VariantContextData);

  let field = props.field;

  let field_options = Object.values(contextData.objects.variant.field_options)
    .filter(
      (field_option) =>
        field_option.field_id == field.id && field_option.toBeDeleted !== true
    )
    .sort(function (a, b) {
      return a.position - b.position;
    });

  const parsedLabelLength = (label) => {
    if (!props.label_max_length) {
      return label;
    }

    return label && label.length > props.label_max_length
      ? label.substr(0, props.label_max_length).trim() + "..."
      : label;
  };

  return (
    <React.Fragment>
      {field_options.map((field_option) => {
        const label = field_option.label
          ? $("<div/>").html(parsedLabelLength(field_option.label)).text()
          : parsedLabelLength(field_option.value);

        return (
          <div
            key={`field-option-mapping-${field_option.id}`}
            className="flex items-center gap-2 w-full mb-3"
          >
            <div
              className="min-w-0 w-[38%] shrink-0 bg-slate-100 dark:bg-slate-800 text-black dark:text-white text-xl px-3 py-2 rounded-md truncate"
              title={label}
            >
              {label}
            </div>
            <div className="shrink-0 text-xl text-slate-400">→</div>
            <div className="min-w-0 flex-1">
              <VariantBuilderSetting
                object={field_option}
                setting_name="[jump_field_id]"
                setting_type="dropdown"
                object_type="field_options"
                object_id={field_option.id}
                value={
                  field_option.jump_field_id
                    ? field_option.jump_field_id + ""
                    : field.options["jump-field-id"]
                    ? field.options["jump-field-id"]
                    : ""
                }
                options={props.fieldsDropdown}
                classNames="!my-0 !px-0"
              />
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default FieldSettingsQuestionMapping;
